import React from 'react';
import FaIcon from './FaIcon';

// Shared list-page shell for Messages (CD-5259) and Downloads (CD-5260).
// Fixed header (context strip + toolbar); only the card list scrolls. Named
// slots only — deliberately not a render-props table (the rows differ per page).
function BravoListPage(props) {
  return (
    <div className='contentwrapper'>
      <div className='bravo-ds blist-page'>
        {props.headerActions ? <div className='blist-actions'>{props.headerActions}</div> : null}

        <div className='blist-head'>
          <div className='context'>
            <div className='breadcrumb'>{props.breadcrumb}</div>
            {props.chip ? <div className='meta'>{props.chip}</div> : null}
          </div>

          <div className='toolbar blist-toolbar'>
            {props.countPill}
            <span className='sp' />
            {props.toolbarActions}
          </div>
        </div>

        {props.isEmpty ? (
          <div className='empty-state'>
            <div className='ei'>
              <FaIcon iconName={props.emptyState.icon} />
            </div>
            <b>{props.emptyState.title}</b>
            <span>{props.emptyState.subtitle}</span>
          </div>
        ) : (
          <div className='blist-scroll'>{props.children}</div>
        )}
      </div>
      {props.overlay}
    </div>
  );
}

BravoListPage.defaultProps = {
  breadcrumb: null,
  chip: null,
  countPill: null,
  toolbarActions: null,
  headerActions: null,
  overlay: null,
  isEmpty: false,
  emptyState: { icon: '', title: '', subtitle: '' },
};

export default BravoListPage;
